export enum eTypeCreationSource {
  'Internal' = 1,
  'External' = 2
}
